module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "What class is this RoundTable for?",
      "size": "md",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.handleCancelPremade()
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full px-6 pb-3.5 min-h-1/5 overflow-y-auto overflow-x-hidden"
  }, [_c('div', {
    staticClass: "h-full flex flex-col"
  }, [_c('header', {
    staticClass: "py-5 px-5 border-t border-r border-l border-solid border-gray-200 bg-gray-100 rounded-t-md",
    attrs: {
      "id": "header-information-course"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3",
    attrs: {
      "id": "select_course_component"
    }
  }, [_c('div', {
    staticClass: "bg-blueGray-700 rounded-full p-2.5"
  }, [_c('img', {
    staticClass: "h-4 w-4",
    attrs: {
      "src": "/static/roundtable_options_create/courses_icon.svg",
      "alt": "course_parlay"
    }
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-base font-poppins text-blueGray-800 font-semibold"
  }, [_vm._v("\n                Select a Course\n              ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search_course"
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 bg-white border border-solid border-gray-300 rounded-md w-56 px-3 py-1.5 focus-within:border-blueGray-800"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-700"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchCourse),
      expression: "searchCourse"
    }],
    staticClass: "w-full bg-white text-gray-800 focus-within:border-white border-white",
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchCourse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchCourse = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('main', {
    staticClass: "overflow-y-auto h-1 flex-grow rounded-b bg-gray-100 border-r border-b border-l border-gray-200 border-solid"
  }, [_c('ul', {
    staticClass: "px-5"
  }, [_vm._l((_vm.coursesFiltered), function(course, index) {
    return _c('li', {
      key: index,
      staticClass: "flex mb-2 justify-between bg-white px-5 py-3.5 rounded-md hover:border-primary border border-solid border-gray-200 cursor-pointer",
      class: {
        'border-primary': _vm.isCourseSelected(course),
        'opacity-50 cursor-not-allowed': !_vm.isCourseSelected(course) && _vm.selected_courses.length >= 3
      },
      on: {
        "click": function($event) {
          return _vm.handleToggleCourse(course)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('h6', {
      staticClass: "hover:underline"
    }, [_vm._v(_vm._s(course.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-1.5 text-gray-500 font-light"
    }, [_c('span', [_vm._v(_vm._s(course.sections[0]))])])]), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "aria-disabled": !_vm.isCourseSelected(course) && _vm.selected_courses.length >= 5,
        "is_checked": _vm.isCourseSelected(course)
      }
    })], 1)
  }), _vm._v(" "), (_vm.getCourses.length === 0) ? _c('div', [_c('div', {
    staticClass: "flex justify-center items-center mb-1"
  }, [_c('pl-spinner')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('span', [_vm._v("Loading Courses")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "px-6 border border-solid border-coolGray-200 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-800 :hover:text-gray-900 font-medium disabled:opacity-50",
    on: {
      "click": function($event) {
        return _vm.handleCancelPremade()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": _vm.getProfile.activity_passes + ' RoundTables left. Click to upgrade account.',
      "positionTooltip": "relative",
      "styleTooltip": "-top-10"
    }
  }, [(!_vm.getProfile.is_paid) ? _c('button', {
    staticClass: "inline-flex mr-1.5 hover:text-gray-900 items-center justify-center border border-solid border-coolGray-200 w-10 h-10 text-gray-700 transition-colors duration-150 bg-coolGray-50 rounded focus:shadow-outline hover:bg-coolGray-100",
    on: {
      "click": _vm.goToUpgradeAccount
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket text-base text-pinky"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.$route.query.premade_id) ? _c('button', {
    staticClass: "px-4 py-2 hover:bg-gray-100 rounded text-gray-800 border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.handleOpenNewCourseModal()
      }
    }
  }, [_vm._v("\n              New Course\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "disabled:opacity-50 flex px-5 py-2 bg-primary border border-solid border-primary hover:border-primary-dark items-center rounded cursor-pointer text-white font-medium",
    attrs: {
      "disabled": _vm.selected_courses.length ? false : true
    },
    on: {
      "click": function($event) {
        return _vm.handleCreatePremadeRoundtable()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.isCreating ? 'Creating RoundTable' : 'Create RoundTable'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreating),
      expression: "isCreating"
    }],
    staticClass: "loader"
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-464dd13f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/newPremadeModal/newPremadeModal.vue
// module id = 1391
// module chunks = 61